"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _Button = require("../Button");
var _Text = require("../Text");
var _date = require("@qwkin/date");
var _helpers = require("@qwkin/helpers");
var _WeekdaySelector = require("./WeekdaySelector.styles");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var WeekdaySelector = function WeekdaySelector(_ref) {
  var title = _ref.title,
    initialValue = _ref.initialValue,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? _helpers.identity : _ref$onChange,
    _ref$enabledSelectAll = _ref.enabledSelectAll,
    enabledSelectAll = _ref$enabledSelectAll === void 0 ? true : _ref$enabledSelectAll;
  var _useState = (0, _react.useState)(initialValue !== null && initialValue !== void 0 ? initialValue : []),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    selectedDays = _useState2[0],
    setSelectedDays = _useState2[1];
  var isSelectedAll = selectedDays.length === _date.weekDays.length;
  var onSelectAll = function onSelectAll() {
    setSelectedDays(_date.weekDays);
    onChange(_date.weekDays);
  };
  var onUnselectAll = function onUnselectAll() {
    setSelectedDays([]);
    onChange([]);
  };
  var onChangeSelectedDays = function onChangeSelectedDays(day) {
    var selected = [];
    if (selectedDays.indexOf(day) !== -1) {
      selected = selectedDays.filter(function (value) {
        return value !== day;
      });
      setSelectedDays(selected);
    } else {
      selected = [].concat((0, _toConsumableArray2["default"])(selectedDays), [day]);
      setSelectedDays(selected);
    }
    onChange(selected);
  };
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_WeekdaySelector.SelectorHeader, null, title && /*#__PURE__*/_react["default"].createElement(_Text.Text, {
    weight: "bold"
  }, title), enabledSelectAll && /*#__PURE__*/_react["default"].createElement(_Button.Button, {
    dense: true,
    icon: isSelectedAll ? 'uncheck-all' : 'check-all',
    onClick: isSelectedAll ? onUnselectAll : onSelectAll
  }, isSelectedAll ? 'Unselect All' : 'Select All')), /*#__PURE__*/_react["default"].createElement(_WeekdaySelector.DaysList, null, _date.weekDays.map(function (day) {
    return /*#__PURE__*/_react["default"].createElement(_WeekdaySelector.ChipSelectable, {
      isActive: selectedDays.indexOf(day) !== -1,
      onClick: function onClick() {
        return onChangeSelectedDays(day);
      }
    }, day);
  })));
};
var _default = exports["default"] = WeekdaySelector;